import { render, staticRenderFns } from "./ranklist.vue?vue&type=template&id=2a169362&scoped=true"
import script from "./ranklist.vue?vue&type=script&lang=js"
export * from "./ranklist.vue?vue&type=script&lang=js"
import style0 from "./ranklist.vue?vue&type=style&index=0&id=2a169362&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a169362",
  null
  
)

export default component.exports